import { type FC, type PropsWithChildren } from 'react'

export const Layout: FC<PropsWithChildren> = ({ children }) => {
  return (
    <div className="h-full flex flex-col max-w-3xl mx-auto justify-start md:justify-center px-sm md:px-4xl pb-lg">
      {children}
    </div>
  )
}
